module.exports = __webpack_public_path__ + "static/media/YM71_0.7c414e96.jpg";